import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompraIndexComponent } from './compra-index/compra-index.component';
import { CompraUpdateComponent } from './compra-update/compra-update.component';
import { CompraViewComponent } from './compra-view/compra-view.component';
import { CompraCreateComponent } from './compra-create/compra-create.component';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxKuvUtilsModule } from 'ngx-kuv-utils';
import { NgxKuvToolsModule } from 'ngx-kuv-tools';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskModule } from 'ngx-mask';
import { NgxKuvCreateVentaModule } from 'ngx-kuv-venta';
import { SharedModule } from 'src/app/shared/shared.module';
const routes: Routes = [
  { path: 'index', component: CompraIndexComponent },
  { path: 'create', component: CompraCreateComponent },
  { path: '**', redirectTo: 'index' }
];

@NgModule({
  declarations: [
    CompraIndexComponent,
    CompraUpdateComponent,
    CompraViewComponent,
    CompraCreateComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    FormsModule,
    NgxKuvUtilsModule,
    NgxKuvToolsModule,
    NgSelectModule,
    NgxKuvCreateVentaModule,
    NgxMaskModule.forRoot(),
    SharedModule
  ]
})
export class CompraModule { }
